import { NavigationBar } from "@/base/NewselaGlobalLayoutV2/NavigationBar/NavigationBar";
import { useNavigationBarV2Context } from "@/base/NewselaGlobalLayoutV2/NavigationBar/NavigationBar.provider";

export { NavigationBar, useNavigationBarV2Context };
